import React from "react"

import {PageContentInterface} from "../page-content-interface"
import {Cover, CoverPosition} from "../../../../../core/model2/task/properties/cover"
import CoverImageHolder from "../../../../../core/gd-components/cover/image-holder/image-holder"
import page_setCover from "../../actions/set-cover"
import AttachmentsCollection from "../../../../../core/model2/attachment/attachments"

type Props = {
    app             : PageContentInterface
    isFullWidth?    : boolean
    attachments?    : AttachmentsCollection
}

export default function PageCover(props: Props) {

    const project = gd.session.projects.get(props.app.projectId)!

    const onCoverPositionSelected = (position:CoverPosition) => {
        const currentCover = props.app.document?.cover
        if (currentCover) {
            currentCover.position = position
        }

        page_setCover(currentCover)
    }

    const onCoverSelected = (cover?:Cover) => {
        const currentCover = props.app.document?.cover
        if (currentCover && cover) {
            cover.position = currentCover.position
        }

        page_setCover(cover)
    }

    const canEdit = !gd.isSharedView && project.acl.canEditCover

    return (
        <CoverImageHolder cover                     = {props.app.document?.cover}
                          attachments               = {props.attachments}
                          isFullWidth               = {props.isFullWidth}
                          disabled                  = {!canEdit}
                          onCoverPositionSelected   = {onCoverPositionSelected}
                          onCoverSelected           = {onCoverSelected}/>
    )
}
